export enum AdressesLocatorModeEnum {
  SearchAndForm = 'SEARCH_AND_FORM',
  SavedAddresses = 'SAVED_ADDRESSES',
  Full = 'FULL',
}
